/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Rankings" |
*
* @param {Rankings_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_page_title = /** @type {((inputs?: Rankings_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Classificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Classifiche")
	return /** @type {LocalizedString} */ ("Rankings")
});